var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "profile-dropdown",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', {
    staticClass: "profile-username d-none d-lg-inline"
  }, [_vm._v(_vm._s(_vm.username))]), _c('img', {
    staticClass: "profile-image",
    attrs: {
      "src": _vm.profile_picture_url,
      "alt": "Profile"
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.isDropdownOpen ? _c('div', {
    staticClass: "dropdown-content"
  }, [_c('div', {
    staticClass: "dropdown-header"
  }, [_vm._v("Signed in as: " + _vm._s(_vm.username))]), _c('hr', {
    staticClass: "dropdown-divider"
  }), _c('ul', [_c('router-link', {
    staticClass: "dropdown-element",
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProfilePage',
        params: {
          username: this.username
        }
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-account inline-icon"
  }), _vm._v(" Your Profile ")]), _c('router-link', {
    staticClass: "dropdown-element",
    attrs: {
      "tag": "li",
      "to": {
        name: 'SelectSession'
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-magnify inline-icon"
  }), _vm._v(" Your Sessions ")])], 1), _c('hr', {
    staticClass: "dropdown-divider"
  }), _c('ul', [_c('li', {
    staticClass: "dropdown-element"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://simtk.org/plugins/phpBB/indexPhpbb.php?group_id=2385&pluginname=phpBB"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-forum inline-icon"
  }), _vm._v(" Forum ")])]), _c('li', {
    staticClass: "dropdown-element"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://github.com/opencap-org"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-source-repository inline-icon"
  }), _vm._v(" Find on GitHub ")])]), _c('li', {
    staticClass: "dropdown-element"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://github.com/stanfordnmbl/opencap-processing"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-chart inline-icon"
  }), _vm._v(" Data Analysis & Processing ")])]), _c('li', {
    staticClass: "dropdown-element"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://www.opencap.ai/best-practices"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-help inline-icon"
  }), _vm._v(" Best Practices ")])]), _c('li', {
    staticClass: "dropdown-element"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://mobilize.stanford.edu/wp-content/uploads/2022/12/OpenCap-QA-Final.pdf"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-frequently-asked-questions inline-icon"
  }), _vm._v(" FAQ ")])]), _c('li', {
    staticClass: "dropdown-element"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://www.opencap.ai/terms-conditions"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-document-edit inline-icon"
  }), _vm._v(" Terms and Conditions ")])]), _c('li', {
    staticClass: "dropdown-element"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://docs.google.com/document/d/1DBw9LVAuUwgz713037VQjsaD8sj2-AN_hzga_7kXtXI/edit"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-eye inline-icon"
  }), _vm._v(" Data Privacy and Security ")])]), _c('li', {
    staticClass: "dropdown-element"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://github.com/stanfordnmbl/opencap-core/issues"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-bug inline-icon"
  }), _vm._v(" Bug Report ")])])]), _c('hr', {
    staticClass: "dropdown-divider"
  }), _c('ul', [_c('li', {
    staticClass: "dropdown-logout",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.openLogoutDialog.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-logout inline-icon"
  }), _vm._v(" Logout ")])])]) : _vm._e()]), _c('v-dialog', {
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "retain-focus": false
    },
    model: {
      value: _vm.showLogoutDialog,
      callback: function ($$v) {
        _vm.showLogoutDialog = $$v;
      },
      expression: "showLogoutDialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "blue"
    }
  }, [_vm._v("mdi-logout")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Are you sure you want to log out?")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "white",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.showLogoutDialog = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c('v-btn', {
    attrs: {
      "color": "white",
      "text": ""
    },
    on: {
      "click": _vm.confirmLogout
    }
  }, [_vm._v(" Log out ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }